<template>
  <div class="home">
    <head-com></head-com>
    <div class="main">
      <el-breadcrumb class="target" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/online' }">返回</el-breadcrumb-item>
        <el-breadcrumb-item>练习结果</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="result bs">
        <h3 class="title">练习结果</h3>
        <div class="cont">
          <p class="topic">
            练习名称: 安管考试考核A
            <span class="time">交卷时间: 2019-01-25 16：23：27</span>
          </p>
          <div class="score-wrap">
            <p class="tit">您的得分为:</p>
            <div class="score">
              <el-progress class="left" type="circle" :width="90" :percentage="25"></el-progress>
              <div class="right">
                <div class="case">
                  答题情况： 共
                  <span class="num">60</span>题，答对
                  <span class="num">40</span>道，答错
                  <span class="num">20</span>道
                </div>
                <p class="case">答题时长： 50分钟30秒</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="theme bs">
        <h3 class="resolve">试题解析</h3>
        <div class="theme-cont">
          <div class="theme-l">
            <div class="theme-top">
              <div class="choose cl">
                <el-radio class="fl" v-model="choose" label="1">查看全部解析</el-radio>
                <el-radio class="fl" v-model="choose" label="2">只看错题解析</el-radio>
              </div>
              <h3 class="title">1. 施工现场用电工程中，PE线的重复接地点不应少于（ ）。</h3>
              <el-radio-group v-model="radio" class="choose">
                <el-radio :label="1">A. 备选项选项备选项备选项</el-radio>
                <el-radio :label="2">B. 备选项备选项备选项备选项备选项备选项</el-radio>
                <el-radio :label="3">C. 备选项</el-radio>
                <el-radio :label="4">D. 备选项</el-radio>
              </el-radio-group>
            </div>
            <div class="error">回答错误！正确答案：A</div>
            <el-row class="switch">
              <el-button type="primary">上一题</el-button>
              <el-button type="primary">下一题</el-button>
            </el-row>
            <el-collapse class="fold bs" v-model="activeNames" @change="handleChange">
              <el-collapse-item title="查看详解" name="2">
                <div>正确答案为：A</div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <div class="answer bs">
            <h3 class="top">答题卡</h3>
            <ul class="choose-list">
              <li v-for="(item, i) in 3" :key="i">
                <h3 class="list-tit">选择题</h3>
                <span class="menu cur" v-for="(item, j) in 18" :key="j">{{j + 1}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <footer-com></footer-com>
  </div>
</template>

<script>
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";

export default {
  name: "viewResult",
  data() {
    return {
      radio: "1",
      choose: "1",
      activeNames: ["1"]
    };
  },
  components: {
    HeadCom,
    FooterCom
  },
  methods: {
    handleChange(val) {
      console.log(val);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-collapse-item__header {
  color: #409eff;
}
.target {
  line-height: 60px;
}
.result {
  border-radius: 6px;
  background: #fff;
  .title {
    line-height: 40px;
    padding: 0 20px;
    border-bottom: 1px solid #ddd;
  }
  .cont {
    padding: 0 20px 20px 20px;
    .topic {
      line-height: 50px;
    }
    .time {
      color: #acacac;
      font-size: 14px;
      margin-left: 30px;
    }
    .score-wrap {
      .tit {
        line-height: 30px;
      }
      .score {
        display: flex;
        justify-content: space-around;
        align-items: center;
      }
      .case {
        line-height: 30px;
        color: #6f6e6e;
        .num {
          font-size: 18px;
          padding: 0 6px;
          color: #409eff;
        }
      }
    }
  }
}
.theme {
  margin: 30px 0;
  background: #ffffff;
  border-radius: 6px;
  .resolve {
    line-height: 40px;
    border-bottom: 1px solid #dddddd;
    padding: 0 20px;
  }
  .theme-cont {
    display: flex;
    justify-content: space-between;
    padding: 20px 0;
  }
  .theme-l {
    width: 860px;
    padding: 0 20px;
    max-height: 500px;
    overflow: auto;
    .choose {
      padding-bottom: 20px;
    }
    .theme-top {
      border-bottom: 1px solid #dddddd;
    }
    .error {
      // width: 50%;
      background: #f2dede;
      color: #a94442;
      line-height: 40px;
      padding: 0 20px;
      margin-top: 30px;
    }
    .switch {
      padding: 20px;
      text-align: center !important;
    }
    .fold {
      border-radius: 6px;
      padding: 0 20px;
    }
  }

  .title {
    line-height: 40px;
    color: #2c3e50;
  }
}
.answer {
  width: 280px;
  border-radius: 6px;
  max-height: 500px;
  overflow-y: scroll;
  .top {
    text-align: center;
    line-height: 40px;
    border-bottom: 1px solid #ddd;
  }
  .choose-list {
    padding: 20px;
    li {
      padding-bottom: 20px;
    }
  }
  .list-tit {
    line-height: 30px;
  }
  .menu {
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px solid #dddddd;
    border-radius: 4px;
    color: #2c3e50;
    text-align: center;
    line-height: 30px;
    margin: 8px;
    // &:nth-child(5n){
    //   margin-right: 0;
    //   margin-left: 8px;
    // }
  }
}
</style>
